// extracted by mini-css-extract-plugin
module.exports = {"list":"works-card-list_list__XRvLi"};